import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { WebApiDataService } from '../../services/webapi-data.service';
import { SecurityService } from '../../services/security.service';
import { Configuration } from 'src/app/app.configuration.service';
import { environment } from 'src/environments/environment';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public username: string;
  public password: string;
  public fieldTextType: boolean;

  public isAzureAD: boolean | false;
  public isSaving: boolean | false;
  public isCTT: boolean | false;
  public errorMessage: string | '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute, private router: Router, private configuration: Configuration,
    private securityService: SecurityService, private webApiDataService: WebApiDataService) {
  }

  ngOnInit() {
    this.securityService.logout(false, false);

    const hostname = this.document.location.hostname;
    this.isCTT = hostname == 'ctt.boxer.pt' || hostname == 'ctt-qa.boxer.pt' || (!environment.production && environment.isCTT); // || hostname == 'localhost';

    // send ping to wakeup server app
    if (!this.configuration.debugMode) {
      const result = this.webApiDataService.ping()
        .subscribe(() => { },
          (error: any) => console.log(error)
        );
    }
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  public login() {
    this.errorMessage = '';
    if (!this.username && !this.password) {
      this.errorMessage = 'Preencha os campos, Username e Password';
      return;
    }

    this.isAzureAD = false;
    this.isSaving = true;
    this.securityService
      .login(this.username, this.password)
      .subscribe((sucess: any) => {
        if (sucess) {
          this.router.navigate([this.securityService.returnUrl]);
          this.securityService.returnUrl = null;
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Utilizador e/ou Palavra-passe inválidos';
        }
        this.isSaving = false;
      },
        (error: any) => {
          this.isSaving = false;
          this.errorMessage = 'Utilizador e/ou Palavra-passe inválidos';
          console.log(error);
        });
  }

  public loginAzureAD() {
    this.errorMessage = '';
    this.isAzureAD = true;
    this.isSaving = true;

    this.securityService
      .loginAzureAD()
      .subscribe((sucess: any) => {
        if (sucess) {
          this.router.navigate([this.securityService.returnUrl]);
          this.securityService.returnUrl = null;
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Utilizador e/ou Palavra-passe inválidos';
        }
        this.isSaving = false;
      },
        (error: any) => {
          this.isSaving = false;
          this.errorMessage = 'Utilizador e/ou Palavra-passe inválidos';
          console.log(error);
        });
  }
}
